import lazyLoading from "./lazyLoading";

export default {
  name: "XXX",
  path: "/mikrobiologija",
  component: lazyLoading("mikrobiologija/Mikrobiologija"),
  meta: {
    default: false,
    title: "XXX",
    class: "primary",
    show: false,
    iconClass: "fa fa-bug",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/mikrobiologija.js